import { FC } from "react";

import { css } from "@emotion/react";
import { Box, Typography } from "@mui/material";

export const MockPageHeader: FC = () => {
  return (
    <Box
      css={css({
        marginLeft: "10%",
        marginTop: 50,
      })}
    >
      <Typography variant="h1">A story about some finance stuff</Typography>
      <Typography variant="h2">A vague subtitle</Typography>
    </Box>
  );
};
